import { ORGANIZATIONS } from '../constants';

export const COMPANIES = 'companies';

export const goToExternalCompanies = orgId => `${ORGANIZATIONS}/${orgId}/${COMPANIES}`;
